import React, { useRef, useCallback } from 'react';
import { useIntersectionObserver } from '@atresmedia/a3utils';
import { func, number, oneOf, arrayOf, node, shape, string } from 'prop-types';

function InfiniteScroller({ onLoadMore, children, observerConfig }) {
  const containerRef = useRef();
  const loaderRef = useRef();

  const handleLoad = useCallback(
    data => {
      if (data[0].isIntersecting) {
        if (onLoadMore) {
          onLoadMore();
        }
      }
    },
    [onLoadMore]
  );

  useIntersectionObserver(loaderRef, handleLoad, observerConfig);

  return (
    <div ref={containerRef} className="infinite-scroller">
      {children}
      <div
        className="infinite-scroller-loader"
        key="infinite-scroller-loader"
        ref={loaderRef}
        style={{ height: 10, background: 'transparent' }}
      />
    </div>
  );
}

InfiniteScroller.propTypes = {
  onLoadMore: func,
  children: oneOf([node, arrayOf(node)]),
  observerConfig: shape({ root: node, rootMargin: string, threshold: number })
};

InfiniteScroller.defaultProps = {
  onLoadMore: null,
  children: null,
  observerConfig: {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  }
};

export default InfiniteScroller;
